import { useState, useEffect } from "react";

import { GetRecommendedSiteNameResponse } from "@atlassiansox/asc-stargate";

import { useUserContext } from "@/components/user-context";
import { useBxpWebStargateClient } from "@/libraries/bxp-web-stargate-client/src/hook";

import { useSiteNameContext } from "../site-name-context";

export interface UseRecommendedSiteNameProps {
    onError?: (error: unknown) => void;
}

export function useRecommendedSiteName(
    props: UseRecommendedSiteNameProps = {}
) {
    const {
        siteNameValueState: [siteNameValue, setSiteNameValue],
        recommendedSiteNameValueState: [
            recommendedSiteName,
            setRecommendedSiteName
        ]
    } = useSiteNameContext();

    const [siteNamePopulated, setSiteNamePopulated] = useState<boolean>();

    const client = useBxpWebStargateClient();
    const {
        user: { email }
    } = useUserContext();

    useEffect(() => {
        if (email) {
            client
                .getRecommendedSiteName({
                    email
                })
                .then((result: GetRecommendedSiteNameResponse) =>
                    setRecommendedSiteName(result.recommendedName)
                )
                .catch(props.onError);
        }
    }, [email]);

    useEffect(() => {
        if (siteNamePopulated) {
            // take no action because site name was already changed via either user interaction or site-name recommendation
            return;
        }
        if (siteNameValue) {
            // user has already started typing, let's not overwrite their input with a recommended site name
            setSiteNamePopulated(true);
        } else if (recommendedSiteName) {
            setSiteNameValue(recommendedSiteName);
            setSiteNamePopulated(true);
        }
    }, [siteNamePopulated, siteNameValue, recommendedSiteName]);
}
